import { buildCashOutMatrixReferenceRows } from "../../config/cashOutMatrixConfig";

export function aggregateCashOutAdminMetrics({ ledgerRows, rewardsWallet }) {
  const byType = {};
  let totalVolume = 0;

  ledgerRows.forEach((row) => {
    const amt = Number(row.amount) || 0;
    const t = row.transactionType || "OTHER";
    byType[t] = (byType[t] || 0) + amt;
    totalVolume += amt;
  });

  const planRows = buildCashOutMatrixReferenceRows();
  const planGrandCashOut = planRows.reduce(
    (s, r) => s + r.cashOutMoney,
    0
  );

  return {
    rewardsWallet,
    ledgerByType: byType,
    ledgerEntryCount: ledgerRows.length,
    ledgerTotalVolume: totalVolume,
    planRows,
    planGrandCashOut,
  };
}
